/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Days between two dates`)
};

const es_dd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Días entre dos fechas`)
};

const de_dd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tage zwischen zwei Daten`)
};

const nl_dd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dagen tussen twee datums`)
};

const fr_dd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jours entre deux dates`)
};

const it_dd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giorni tra due date`)
};

const pt_br2_dd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dias entre duas datas`)
};

const pt_dd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dias entre duas datas`)
};

const ja_dd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つの日付間の日数`)
};

const zh_dd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两个日期之间的天数`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_nav_main_desc", locale)
	if (locale === "en") return en_dd_nav_main_desc(inputs)
	if (locale === "es") return es_dd_nav_main_desc(inputs)
	if (locale === "de") return de_dd_nav_main_desc(inputs)
	if (locale === "nl") return nl_dd_nav_main_desc(inputs)
	if (locale === "fr") return fr_dd_nav_main_desc(inputs)
	if (locale === "it") return it_dd_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_dd_nav_main_desc(inputs)
	if (locale === "pt") return pt_dd_nav_main_desc(inputs)
	if (locale === "ja") return ja_dd_nav_main_desc(inputs)
	return zh_dd_nav_main_desc(inputs)
};